import React from 'react';
import PolicyPageLayout from '../components/PolicyPageLayout';

const ShippingPolicyPage = () => {
  return (
    <PolicyPageLayout title="Shipping Policy">
      <h2>Shipping Costs</h2>
      <p>
        Shipping costs are calculated at checkout based on the weight of your order and your delivery location. The total shipping fee will be clearly displayed before you confirm your payment.
      </p>
      
      <h2>Order Dispatch</h2>
      <p>
        All orders are dispatched only after a successful confirmation call with the customer. This call will be made within 24 hours of you placing the order.
      </p>
      
      <h2>Damaged or Incorrect Items</h2>
      <p>
        We pack all our orders with the utmost care to ensure they reach you in perfect condition. In the rare event that your order is damaged during shipping or you receive the wrong item, we are here to help.
      </p>
      
      <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4 my-6">
        <h4 className="font-bold text-yellow-800">Important: Unboxing Video Required</h4>
        <p className="text-yellow-700">
          To process any claim for a damaged or incorrect item, you <strong>must record a clear and continuous unboxing video</strong> of the parcel. The video must be uncut and unedited, showing the parcel being opened and the item's condition. We cannot process any exchanges or refunds without this video proof.
        </p>
      </div>

      <p>
        If you have an issue, please send the unboxing video along with your order number to our email at <strong>monvistyles@gmail.com</strong> or on WhatsApp at <strong>+91 9676111210</strong>.
      </p>
    </PolicyPageLayout>
  );
};

export default ShippingPolicyPage;